import { hubService } from '@/services';
import HubVM from '@/view-model/hub-management/HubVM';
import PostHubFormDto from '@/form/form-dto/hub-management/PostHubFormDto';
import AxiosResponse from '@/error/AxiosResponse';
export default {
    async getHubInfo({ commit }, hubId) {
        const { data } = await hubService.getManagementHub(hubId);
        const payload = new HubVM(data);
        commit('GET_HUB_INFO', payload);
    },
    async resetHubInfo({ commit }) {
        commit('RESET_HUB_INFO');
    },
    async editHubInfo(_, { hubId, type = 'basic-info', submitData }) {
        try {
            const formDataDto = new PostHubFormDto(submitData);
            let reqData = null;
            if (type === 'basic-info') {
                // eslint-disable-next-line no-param-reassign
                type = 'basic';
                reqData = formDataDto.convertEditBasicInfoSubmitDataToPayload();
            }
            if (type === 'worker-operation-setting') {
                // eslint-disable-next-line no-param-reassign
                type = 'worker-operation';
                reqData = formDataDto.convertEditWorkerOperationInfoSubmitDataToPayload();
            }
            if (type === 'adjustment-operation-setting') {
                // eslint-disable-next-line no-param-reassign
                type = 'adjustment-operation';
                reqData = formDataDto.convertEditAdjustmentOperationInfoSubmitDataToPayload();
            }
            await hubService.putHubInfo(hubId, type, reqData);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            if (error instanceof AxiosResponse) {
                return {
                    isSuccess: false,
                    reason: error.data.error.reason,
                    message: error.data.error.message,
                };
            }
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
};
